export default __webpack_public_path__ + "static/media/illustration-health-1-w@3x.e8ce13b0.webp";